export default __webpack_public_path__ + "static/media/heartNet.bb16a396.png";